// This file is AUTOGENERATED, do not edit it manually!!!

export const activityList = {
    Activities: '1#Atividade#Atividades',
    Activities_Text: '1#{0} Atividade#{0} Atividades',
    activities_without_dates: 'Atividades sem datas',
    Activity: 'Atividade',
    Activity_Billing: 'Faturável',
    Activity_Cost: 'Custo da Atividade',
    Activity_CostVariance: 'Variação de Custo',
    Activity_HoursLeft: 'restante',
    Activity_InternalCost: 'Custo Real',
    Activity_Profit: 'Lucro',
    Add_Task: 'Adicionar Tarefa',
    AITaskGeneration_projectName: 'Nome',
    AITaskGeneration_retry: 'Tentar Novamente',
    AITaskGeneration_title: 'Criar plano de projeto com IA',
    All_Saved_Views: 'Todas as visualizações salvas',
    Apply_Text: 'Aplicar',
    apply_wbs_sorting: 'Aplicar classificação WBS',
    Archive_Success_Message: 'O projeto \"{0}\" foi arquivado',
    Baseline_Text: 'Linha de Base',
    Board_CreateTaskInProjectPlaceholder: 'Criar no projeto',
    Board_ShowMore: 'Mostrar mais',
    Browse_Views: 'Explorar visualizações',
    Budget_problem_project: 'Custo Real ultrapassa Orçamento Total',
    Budget_problem_task: 'Custo Real de Mão de Obra ultrapassa Orçamento Total',
    Budget_Text: 'Orçamento',
    Budget_warning_project: 'Custo EAC ultrapassa Orçamento Total',
    Budget_warning_task: 'Custo EAC de Mão de Obra ultrapassa Orçamento Total',
    By_Text: 'por',
    ChooseTemplateDropdownLabel: 'Criar um projeto com base em um modelo existente',
    Counter: 'Contador de Projetos/Atividades',
    CPI_Problem: 'CPI está abaixo do limite',
    Create: 'Criar',
    create_snapshot: 'Instantâneo do Projeto',
    CreateNewItem: 'Digite aqui para criar um novo projeto ou atividade...',
    CreateProject_Tooltip: 'Criar um novo projeto',
    CriticalPath_Text: 'Caminho Crítico',
    CustomField_No: 'Não',
    CustomField_Yes: 'Sim',
    DayPluralFormat: '1#Dia#Dias',
    Default_Text: 'Padrão',
    Delete_Confirmation_Title: 'Apagar estes objetos?',
    Delete_Entity_Confirmation_Archive_Description: '<b>Em vez disso, você também pode arquivar os dados do projeto e restaurá-los conforme necessário.</b>',
    Delete_Text: 'Apagar',
    DeleteEntityConfirmation: 'incluindo todos os registros de tempo, mensagens e arquivos anexados {0}. A ação não pode ser desfeita!',
    DeletePermanently: 'Apagar permanentemente',
    DeleteVerb: '1#serão apagados permanentemente#serão apagados permanentemente',
    DeleteVerbActivity: '1#serão apagados permanentemente#serão apagados permanentemente',
    Dependency_AddMore_Text: 'Adicionar mais dependências',
    Dependency_Cancel: 'Cancelar',
    Dependency_Choose: 'Selecionar atividade ou digitar uma palavra-chave...',
    Dependency_days: 'dias',
    Dependency_DelayWarningExample: 'Exemplo: -34, 42',
    Dependency_DelayWarningText: 'Digite números de -1000 a 1000',
    Dependency_DependencyCycle: 'Desculpe, a dependência não pode ser criada porque a atividade selecionada cria um loop de dependência.',
    Dependency_DependencyType_Text: 'Tipo de Dependência',
    Dependency_DependsOn_Text: 'Depende de',
    Dependency_FinishToStart_Minus1: 'Atividade começa um dia antes de {0} terminar',
    Dependency_FinishToStart_Minus1_Pattern: 'Atividade começa <b>um dia antes</b> de \"{0}\" terminar',
    Dependency_FinishToStart_Minus2: 'Atividade começa {1} antes de {0} terminar',
    Dependency_FinishToStart_Minus2_Pattern: 'Atividade começa <b>{1} antes</b> de \"{0}\" terminar',
    Dependency_FinishToStart_Plus0: 'Atividade começa no mesmo dia em que {0} termina',
    Dependency_FinishToStart_Plus0_Pattern: 'Atividade começa <b>no mesmo dia</b> em que \"{0}\" termina',
    Dependency_FinishToStart_Plus1: 'Atividade começa um dia depois de {0} terminar',
    Dependency_FinishToStart_Plus1_Pattern: 'Atividade começa <b>um dia depois</b> de \"{0}\" terminar',
    Dependency_FinishToStart_Plus2: 'Atividade começa {1} depois de {0} terminar',
    Dependency_FinishToStart_Plus2_Pattern: 'Atividade começa <b>{1} depois</b> de \"{0}\" terminar',
    Dependency_FinishWhenStarted_Text: 'Atividade terminará quando \"{0}\" começar',
    Dependency_FinishWhenStarted_Title: 'Início para Término',
    Dependency_Lag_Text: 'Lag',
    Dependency_ParentChildRelationship: 'Desculpe, a dependência não pode ser criada porque uma das atividades é pai e a outra é filha (subatividade).',
    Dependency_Reason: 'Motivo',
    Dependency_Remove_Text: 'Remover',
    Dependency_RemoveSingleDependency_Text: 'Remover dependência',
    Dependency_Save: 'Salvar',
    Dependency_SelectDependsOn_Text: 'Selecionar Dependência de',
    Dependency_StartsWhenFinished_Text: 'Atividade começa quando \"{0}\" terminar',
    Dependency_StartsWhenFinished_Title: 'Término para Início',
    Dependency_StartsWhenStarted_Text: 'Atividade começa quando \"{0}\" começar',
    Dependency_StartsWhenStarted_Title: 'Início para Início',
    Dependency_StartToFinish_Minus1: 'Atividade termina um dia antes de {0} começar',
    Dependency_StartToFinish_Minus1_Pattern: 'Atividade termina <b>um dia antes</b> de \"{0}\" começar',
    Dependency_StartToFinish_Minus2: 'Atividade termina {1} antes de {0} começar',
    Dependency_StartToFinish_Minus2_Pattern: 'Atividade termina <b>{1} antes</b> de \"{0}\" começar',
    Dependency_StartToFinish_Plus0: 'Atividade termina no mesmo dia em que {0} começa',
    Dependency_StartToFinish_Plus0_Pattern: 'Atividade termina <b>no mesmo dia</b> em que \"{0}\" começa',
    Dependency_StartToFinish_Plus1: 'Atividade termina um dia depois de {0} começar',
    Dependency_StartToFinish_Plus1_Pattern: 'Atividade termina <b>um dia depois</b> de \"{0}\" começar',
    Dependency_StartToFinish_Plus2: 'Atividade termina {1} depois de {0} começar',
    Dependency_StartToFinish_Plus2_Pattern: 'Atividade termina <b>{1} depois</b> de \"{0}\" começar',
    Dependency_StartToStart_Minus1: 'Atividade começa um dia antes de {0} começar',
    Dependency_StartToStart_Minus1_Pattern: 'Atividade começa <b>um dia antes</b> de \"{0}\" começar',
    Dependency_StartToStart_Minus2: 'A atividade começa {1} antes do início de {0}',
    Dependency_StartToStart_Minus2_Pattern: 'A atividade começa <b>{1} antes</b> do início de \"{0}\"',
    Dependency_StartToStart_Plus0: 'A atividade começa no mesmo dia em que {0} começa',
    Dependency_StartToStart_Plus0_Pattern: 'A atividade começa <b>no mesmo dia que</b> \"{0}\" começa',
    Dependency_StartToStart_Plus1: 'A atividade começa no dia seguinte ao início de {0}',
    Dependency_StartToStart_Plus1_Pattern: 'A atividade começa <b>no dia seguinte ao</b> início de \"{0}\"',
    Dependency_StartToStart_Plus2: 'A atividade começa {1} depois do início de {0}',
    Dependency_StartToStart_Plus2_Pattern: 'A atividade começa <b>{1} depois</b> do início de \"{0}\"',
    Dependency_Warning_Text: 'A operação não pôde ser concluída. ',
    Details: 'Detalhes',
    Edit_Text: 'Editar',
    empty_sorting_list: 'Nenhuma opção de classificação encontrada',
    EnterProjectName: 'Digite o nome do projeto',
    EnterTaskName: 'Digite o nome da tarefa',
    EnterViewName_Text: 'Digite o nome da visualização',
    Error_DragAndDrop_BreakingHierarchy: 'Uma atividade não pode ser filha da sua própria subatividade.',
    Error_DragAndDrop_ChangeParentInFlattenView: 'Por favor, mude para visualização hierárquica para alterar a hierarquia das atividades.',
    Error_DragAndDrop_CycleDependencies: 'Essa operação criará uma dependência cíclica (por exemplo, a Tarefa A depende da Tarefa B, a Tarefa B depende da Tarefa A).',
    Error_DragAndDrop_DifferentProjects: 'Você não pode mover uma atividade para outro projeto (use os detalhes da atividade).',
    Error_DragAndDrop_ReorderWithSorting: 'Para reordenar atividades, a classificação ascendente da EAP deve ser aplicada.',
    Error_PresetNotFound: 'A visualização selecionada foi excluída ou deixou de ser compartilhada. Para continuar, atualize a página.',
    EstimatedHours_problem: 'As horas reais excedem as horas estimadas',
    export_activities: 'Atividades',
    export_activities_expanded_only: 'Atividades (apenas expandidas)',
    Export_Activities_Text: 'Exportar Atividades para CSV',
    Export_Import_Text: 'Exportar e Importar',
    export_projects: 'Projetos',
    Export_Projects_Text: 'Exportar Projetos para CSV',
    flat_view: 'Visualização plana',
    From: 'de',
    Group_By_Portfolio: 'Agrupar por portfólio',
    group_by_project: 'Agrupar por projeto',
    Hide_Counter: 'Ocultar contagem de Projetos/Atividades',
    Hide_Text: 'Ocultar',
    hide_uncategorized_tasks: 'Ocultar atividades que não correspondem a nenhum calendário',
    Hours_Short_Text: 'h',
    Import_CSV_Text: 'Importar do CSV',
    Import_MSProject_Text: 'Importar do MS Project',
    Import_Text: 'Importar',
    Indicator_Counter_Snooze_Tooltip: '1#{0} item com problemas#{0} itens com problemas',
    Indicator_Counter_Tooltip: 'Número de atividades em risco',
    Indicator_Project_Tooltip: 'O projeto precisa de atenção em:',
    Indicator_Snooze_1_Week: 'Por 1 semana',
    Indicator_Snooze_4_Hours: 'Por 4 horas',
    Indicator_Snooze_Cancel: 'Cancelar adiamento',
    Indicator_Snooze_Custom: 'Personalizado',
    Indicator_Snooze_Custom_Modal_Header: 'Indicação do adiamento',
    Indicator_Snooze_Forever: 'Para sempre',
    Indicator_Snooze_Menu_Text: 'Adiar indicação de problema',
    Indicator_Snooze_Message: 'Indicação de problema adiada para você até {0}.',
    Indicator_Snooze_Message_Forever: 'Indicação de problema adiada para você para sempre.',
    Indicator_Snooze_Until_Tomorrow: 'Até amanhã',
    Indicator_Task_Tooltip: 'A atividade precisa de atenção em:',
    Learn_More_Text: 'Saber mais',
    Loading_Text: 'Carregando...',
    More_Tasks: '{0} mais',
    MoreActions_AddAIActivities: 'Criar plano de projeto com IA',
    MoreActions_AddNextActivity: 'Adicionar próxima atividade',
    MoreActions_AddSubActivity: 'Adicionar subatividade',
    MoreActions_SetAsMilestone: 'Definir como marco',
    MoreActions_UnsetAsMilestone: 'Remover como marco',
    My_Presets: 'Minhas visualizações',
    My_Text: 'Eu',
    MyPresetName_Text: 'Meus',
    NewProject: 'Novo projeto',
    NewProjectBasedOn: 'Novo projeto com base em {0}',
    NewTask: 'Nova tarefa',
    no_custom_field_value_label: 'n/d',
    No_Portfolio: 'Sem Portfólio',
    No_Templates_Text: 'Nenhum modelo encontrado.',
    NoSavedViews_Text: 'Nenhuma visualização salva',
    Of: 'de',
    old_sort_az: 'A→Z',
    old_sort_za: 'Z→A',
    parent_activities: 'Atividades pai',
    Portfolios_Text: '1#{0} Portfólio#{0} Portfólios',
    preset_delete: 'Excluir visualização',
    preset_delete_confirmation: 'Excluir visualização \"{0}\"?',
    preset_rename: 'Renomear visualização',
    preset_save: 'Salvar visualização',
    preset_saveAs: 'Salvar visualização como',
    preset_share: 'Compartilhar com todos neste espaço',
    preset_unshare_confirmation: 'Cancelar compartilhamento da visualização {0}?',
    Project: 'Projeto',
    Project_ActualBudgetProfitability: 'Rentabilidade Orçamentária Real',
    Project_BudgetedCost: 'Orçamento Total do Projeto',
    Project_CostVariance: 'Variação de Custo',
    Project_EstimatedBudgetProfitability: 'Rentabilidade Orçamentária Estimada',
    Project_Expenses: 'Despesas',
    project_info: 'Informações do Projeto',
    Project_InternalCost: 'Custo Real',
    Project_ProjectBilling: 'Faturamento do Projeto',
    Project_ProjectProfit: 'Lucro do Projeto',
    Project_ProjectProfitability: 'Rentabilidade do Projeto',
    ProjectEndDate_problem: 'O projeto não foi concluído na data de vencimento',
    Projects: '1#Projeto#Projetos',
    Projects_Text: '1#{0} Projeto#{0} Projetos',
    Rename_Text: 'Renomear',
    Restore_Text: 'Restaurar',
    Save_Text: 'Salvar',
    SaveAs_Text: 'Salvar como',
    Share_Text: 'Compartilhar',
    Shared_With_Me: 'Compartilhado comigo',
    show_archived_projects: 'Mostrar projetos arquivados',
    Show_Text: 'Mostrar',
    SortBy_Text: 'Ordenar por',
    SPI_Problem: 'SPI está abaixo do limite',
    SubActivities: '1#Subatividade#Subatividades',
    switchToClassicUI: 'Mudar para o antigo IU',
    switchToNewUI: 'Mudar para o novo IU',
    tab_Board: 'Quadro',
    tab_Calendar: 'Calendário',
    tab_Gantt: 'Gráfico de Gantt',
    tab_Table: 'Tabela',
    TargetProfit_warning: 'Lucro Alvo menor que o Lucro Esperado',
    TargetProfitPercentage_warning: 'Lucro Alvo (%) menor que o Lucro Esperado (%)',
    TaskEndDate_problem: 'A tarefa não foi concluída na data de vencimento',
    TaskEndDate_warning: 'A tarefa termina depois do seu pai',
    TaskStartDate_warning: 'A tarefa começa antes do seu pai',
    Templates_Popup_Title: 'Com base no Modelo:',
    TimerText: '1#{0} segundo#{0} segundos',
    Tools_Menu_Text: 'Ferramentas',
    Tooltip_DefaultPresetIcon: 'Selecionar ou gerenciar visualizações salvas',
    Tooltip_RevertToDefaultPreset: 'Reverter para a visualização padrão',
    Tooltip_SaveDefaultPreset: 'Salvar seu layout atual e filtros como uma Visualização',
    Tooltip_SharedByMePreset: 'Compartilhado por mim',
    TotalTargetRevenue_warning: 'Faturamento Estimado para Fechamento menor que Total de Receitas Alvo',
    Unarchive_Success_Message: 'Projeto \"{0}\" foi desarquivado.',
    uncategorized_tasks: 'Atividades sem calendários',
    Unshare_Text: 'Revogar o compartilhamento',
    View_Project_Link: 'Ver projeto',
    WBSNumber_Text: 'PBS',
    what_to_export: 'O que exportar?',
};
